import { useMutation } from '@tanstack/react-query';

import { axiosInstance } from '~/services';

import { API_ENDPOINT } from '~/constants';

import type {
  TypeApiResponse,
  TypePutReceivingLabelLabelsParams,
  TypePutReceivingLabelLabelsResponse,
} from '~/types/receive.types';

type LabelParams = {
  ownerCode: string;
  params: TypePutReceivingLabelLabelsParams;
};

/**
 * [입고요청관리] 라벨 출력 API
 */
const fetchPutReceivingLabelLabels = async ({ ownerCode, params }: LabelParams) => {
  const { data } = await axiosInstance.put<TypeApiResponse<TypePutReceivingLabelLabelsResponse['data']>>(
    `${API_ENDPOINT.RECEIVE_2.PUT_RECEIVING_LABEL_LABELS}/${ownerCode}/labels`,
    params
  );
  return data.data;
};

/**
 * [입고요청관리] 라벨 출력 Mutation Hook
 * @description 에러 처리는 사용처에서 개별 처리 (dialog 표시)
 */
export const usePutReceivingLabelLabelsMutation = () => {
  return useMutation({
    mutationFn: fetchPutReceivingLabelLabels,
    meta: { silent: true },
  });
};
